'use client';
import { useLayoutEffect, useEffect } from 'react';

const useIsomorphicLayoutEffect = 'undefined' != typeof document ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect };
